import moment from "moment";

moment.locale("ru");

export default moment;
